import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import KanisaActionCard from '../../components/legacy/KanisaActionCard';

import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    seats: Yup.string().required().label('Number of seats'),
});

const SEATS = [1, 2, 3, 4, 5].map((row) => ({ value: row, label: row }));

export default function ServiceRouteScreen() {
    const state = useSelector((st) => st);
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();

    const { services, busy } = state.list2;

    const [bookService, { isLoading }] = useCreateListDataMutation();

    const { church, date, description, name, remaining, time, venue } =
        services.find((s) => s.id.toString() === id.toString()) || {};

    return (
        <Screen loading={busy['services']} title="Book Seats">
            <Grid item xs={12}>
                <div className="d-flex align-items-center flex-column text-center">
                    <Typography sx={{ mb: 4 }} variant="h5">
                        {church?.name}
                    </Typography>
                    <Typography variant="h3">{remaining}</Typography>
                    <Typography variant="h5">Seats Left</Typography>
                </div>
            </Grid>
            <Grid item xs={12}>
                <KanisaActionCard
                    name={name}
                    venue={venue}
                    desc={description}
                    date={date}
                    time={time.start}
                    serviceInner
                />
            </Grid>
            <Grid item xs={12}>
                <div className="d-flex align-items-center flex-column">
                    <Form
                        validationSchema={validate}
                        onSubmit={async (vals) => {
                            const { error, data } = await bookService({
                                list: `services/${id}/bookings`,
                                body: vals,
                            });

                            errorSnackbar(error, enqueueSnackbar);

                            if (data) {
                                enqueueSnackbar('Booking successful');
                            }
                        }}
                        initialValues={{ seats: '' }}
                    >
                        <FormikSelect
                            name="seats"
                            data={SEATS}
                            placeholder="Number of Seats"
                            label="Number of Seats"
                        />
                        <FormikButton loading={isLoading} variant="contained">
                            Book Seats
                        </FormikButton>
                    </Form>
                </div>
            </Grid>
        </Screen>
    );
}
